'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var ErrorText = require('../../typography/ErrorText/ErrorText.js');
require('../../typography/LargeDarkText/LargeDarkText.js');
require('../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../typography/MediumDarkText/MediumDarkText.js');
require('../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../typography/MediumText/MediumText.js');
require('../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../../typography/SmallDarkText/SmallDarkText.js');
require('../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../typography/SmallLinkText/SmallLinkText.js');
require('../../typography/SmallTitleText/SmallTitleText.js');
require('../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../typography/TinyDarkText/TinyDarkText.js');
require('../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../typography/TinyLinkText/TinyLinkText.js');
require('../../typography/TinyTitleText/TinyTitleText.js');
require('../../typography/XXLargeDarkText/XXLargeDarkText.js');
var Grid = _interopDefault(require('@material-ui/core/Grid'));
var Validator = require('../../validation/Validator/Validator.js');
var validators = require('../../validation/validators.js');
var InputWithTopLabel = require('../InputWithTopLabel/InputWithTopLabel.js');
var SelectWithTopLabel = require('../SelectWithTopLabel/SelectWithTopLabel.js');
var styledComponents = require('./styled-components.js');
var validators$1 = require('./validators.js');
var constants = require('./constants.js');

var AddressInput = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var initialData = props.initialData, reporter = props.reporter, _g = props.validationActive, validationActive = _g === void 0 ? false : _g, errorReporter = props.errorReporter, error = props.error, errors = props.errors, _h = props.renderErrors, renderErrors = _h === void 0 ? false : _h;
    var _j = React.useState({
        address1: (_a = initialData === null || initialData === void 0 ? void 0 : initialData.address1) !== null && _a !== void 0 ? _a : '',
        address2: (_b = initialData === null || initialData === void 0 ? void 0 : initialData.address2) !== null && _b !== void 0 ? _b : '',
        city: (_c = initialData === null || initialData === void 0 ? void 0 : initialData.city) !== null && _c !== void 0 ? _c : '',
        zipCode: (_d = initialData === null || initialData === void 0 ? void 0 : initialData.zipCode) !== null && _d !== void 0 ? _d : '',
        state: (_e = initialData === null || initialData === void 0 ? void 0 : initialData.state) !== null && _e !== void 0 ? _e : '',
        country: (_f = initialData === null || initialData === void 0 ? void 0 : initialData.country) !== null && _f !== void 0 ? _f : '',
    }), data = _j[0], setStateData = _j[1];
    var setData = function (newData) {
        setStateData(newData);
        if (reporter) {
            var reportData = tslib.__assign({}, data);
            if (reportData.state === 'default') {
                reportData.state = '';
            }
            reporter(reportData);
        }
    };
    var reportErrors = function (e) {
        if (errorReporter) {
            errorReporter(e);
        }
    };
    var reportAddress1 = function (args0) {
        data.address1 = args0;
        setData(tslib.__assign({}, data));
    };
    var reportAddress2 = function (args0) {
        data.address2 = args0;
        setData(tslib.__assign({}, data));
    };
    var reportCity = function (args0) {
        data.city = args0;
        setData(tslib.__assign({}, data));
    };
    var reportZipCode = function (args0) {
        data.zipCode = args0;
        setData(tslib.__assign({}, data));
    };
    var reportState = function (args0) {
        var _a;
        data.state = String(args0);
        data.country = (_a = constants.StateCountryHash[data.state]) !== null && _a !== void 0 ? _a : 'US';
        setData(tslib.__assign({}, data));
    };
    return (React__default.createElement(Validator, { validators: validators$1.default, data: data, shouldValidate: validationActive, reportErrors: reportErrors, error: error, errors: errors, renderChild: function (_errorProp, errorsProp) { return (React__default.createElement("div", null,
            React__default.createElement(styledComponents.InputDiv, null,
                React__default.createElement(InputWithTopLabel, { title: 'Address', value: data.address1, reporter: reportAddress1, error: validators.isError('Address 1', errorsProp), placeholder: 'Address 1' }),
                renderErrors && React__default.createElement(ErrorText, null, validators.getError('Address 1', errorsProp))),
            React__default.createElement(styledComponents.InputDiv, null,
                React__default.createElement(InputWithTopLabel, { value: data.address2 || '', reporter: reportAddress2, error: false, placeholder: 'Address 2' }),
                renderErrors && React__default.createElement(ErrorText, null, validators.getError('Address 2', errorsProp))),
            React__default.createElement(Grid, { container: true, spacing: 1 },
                React__default.createElement(Grid, { xs: 7, item: true },
                    React__default.createElement(InputWithTopLabel, { value: data.city, reporter: reportCity, error: validators.isError('City', errorsProp), placeholder: 'City' }),
                    renderErrors && React__default.createElement(ErrorText, null, validators.getError('City', errorsProp))),
                React__default.createElement(Grid, { xs: 3, item: true, style: { paddingLeft: '3px', paddingRight: '3px' } },
                    React__default.createElement(SelectWithTopLabel, { title: '', menuItems: constants.States, reporter: reportState, defaultValue: data.state, error: validators.isError('State', errorsProp) }),
                    renderErrors && React__default.createElement(ErrorText, null, validators.getError('State', errorsProp))),
                React__default.createElement(Grid, { xs: 2, item: true },
                    React__default.createElement(InputWithTopLabel, { value: data.zipCode, reporter: reportZipCode, error: validators.isError('Zip Code', errorsProp), placeholder: 'Zip/Postal' }),
                    renderErrors && React__default.createElement(ErrorText, null, validators.getError('Zip Code', errorsProp))),
                React__default.createElement(Grid, { container: true })))); } }));
};

module.exports = AddressInput;
